import React from 'react'
import classNames from 'classnames'

import UserPhoto from 'components/UserPhoto'

import AddIcon from '@material-ui/icons/Add'
import { withStyles, createStyles, WithStyles } from '@material-ui/core'

interface Props {
  photoUrl: string
  showUploadIcon?: boolean
  onPhotoUpload: (file: File) => any // tslint:disable-line:no-any
}

const styles = createStyles({
  root: {
    position: 'relative',
    display: 'inline-block',
  },
  iconContainer: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
  },
  icon: {
    fontSize: 36,
  },
  fadedPhoto: {
    opacity: 0.5,
    cursor: 'pointer',
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

class UserPhotoWithUpload extends React.Component<InjectedProps> {
  fileInput?: HTMLInputElement

  constructor(props: InjectedProps) {
    super(props)
    this.fileInput = undefined
  }

  private handleUpload = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const file = ev.target.files![0]
    this.props.onPhotoUpload(file)
    ev.target.value = ''
  }

  private setFileInput = (el: HTMLInputElement) => {
    this.fileInput = el
  }

  private renderPlusIcon = () => {
    const { classes } = this.props
    return this.props.showUploadIcon
      ? (
        <div className={classes.iconContainer}>
          <AddIcon className={classes.icon} />
        </div>
      )
      : null
  }

  render() {
    const { photoUrl, showUploadIcon, classes } = this.props
    return (
      <div className={classes.root}>
        <input
          type="file"
          accept="image/*"
          ref={this.setFileInput}
          style={{ display: 'none' }}
          onChange={this.handleUpload}
        />
        {this.renderPlusIcon()}
        <UserPhoto
          size="large"
          src={photoUrl}
          className={classNames({ [classes.fadedPhoto]: showUploadIcon })}
          onClick={() => { this.fileInput!.click() }}
        />
      </div>
    )
  }
}

export default withStyles(styles)(UserPhotoWithUpload)
